<div class="spinner-wrapper">
  <mat-spinner color="primary" [diameter]="diameter"></mat-spinner>
</div>
